module.exports = __webpack_public_path__ + "static/media/location.68a211c8.svg";